module.exports = __webpack_public_path__ + "static/fonts/BMKIRANGHAERANG.490e404.woff";